import React from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ProgramForm = ({ program, onChange, simpleMode=false }) => {
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onChange({ ...program, [name]: value });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormControl className="styled-form-control" fullWidth>
                    <TextField
                        id="program-name"
                        name="name"
                        label="Program Name"
                        variant="outlined"
                        value={program.name || ''}
                        onChange={handleInputChange}
                    />
                </FormControl>
            </Grid>
            {(simpleMode == false) && (
                <Grid item xs={12}>
                    <FormControl className="styled-form-control" fullWidth>
                        <TextField
                            id="program-description"
                            name="description"
                            label="Program Description"
                            variant="outlined"
                            value={program.description || ''}
                            onChange={handleInputChange}
                        />
                    </FormControl>
                </Grid>
            )}
            {(simpleMode == false) && (
                <Grid item xs={12}>
                    <FormControl variant="outlined" className="styled-form-control" fullWidth>
                        <InputLabel id="program-status-label">Program Status</InputLabel>
                        <Select
                            labelId="program-status-label"
                            id="program-status-select"
                            name="status"
                            value={program.status || ''}
                            onChange={handleInputChange}
                            label="Program Status"
                        >
                            <MenuItem value="ACTIVE">Active</MenuItem>
                            <MenuItem value="INACTIVE">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            )}
        </Grid>
    );
};

export default ProgramForm;
